import { jsx } from "@emotion/react/jsx-runtime";
import Card from "./Card.mjs";
import useThemeProps from "./useThemeProps.mjs";
function TeaserCard(props) {
  props = useThemeProps({
    props,
    name: "TeaserCard"
  });
  let {
    color = "transparent",
    mediaColspan = 2,
    ...restProps
  } = props;
  return /* @__PURE__ */jsx(Card, {
    color,
    mediaColspan,
    forceHorizontal: true,
    ...restProps
  });
}
export { TeaserCard as default };